import { Link } from "react-router-dom";

var CurrentUser = require("lib/account/CurrentUser");
var WhooosReadingServices = require("lib/web/WhooosReadingServices");

require("layout/basic_site_header.scss");

class BasicSiteHeader extends React.Component {
	constructor(props) {
		super();
		autobind(this);
	}

	logOut(e) {
		$wr.nope(e)
		CurrentUser.logOut();
		window.location = WhooosReadingServices.OuterPages.url("/");
	}

	renderUserDropdown() {
		if (CurrentUser.isLoaded()) {
			var nameLabel = CurrentUser.get().first_name;
		} else {
			var nameLabel = "...";
		}
		return (
			<div className="dropdown">
				<a id="dLabel" role="button" data-toggle="dropdown"
					aria-haspopup="true" aria-expanded="false">
			    	<span className="ellipsisText">{ nameLabel }</span>
			    	<span className="caret"></span>
			  	</a>

				<ul className="dropdown-menu" aria-labelledby="dLabel">
					<li>
						<a href="https://whooosreading.zendesk.com" target="_blank">Help</a>
					</li>
					<li>
						<a href="" onClick={ this.logOut }>Log Out</a>
					</li>
				</ul>
			</div>
		);
	}

	render() {
		var rootPath = "/";
		var leftNav = (
			<div className="leftNav">
				<Link to={ rootPath } className="backLink">
					Back
				</Link>
			</div>
		);

		var centerNav = (
			<div className="centerNav">
				<Link to={ rootPath } className="homeLogoLink">
					<img src={ require("logos/wr-logo.png") } className="wrLogo" />
				</Link>
			</div>
		);

		var rightNav = (
			<div className="rightNav">
				{ this.renderUserDropdown() }
			</div>
		);

		return (
			<div className="hideOnPrint">
				<div className="basicSiteHeader" ref="header">
					<div className="headerContainer">
						{ leftNav }
						{ centerNav }
						{ rightNav }
					</div>
				</div>
			</div>
		)
	}
};


BasicSiteHeader.propTypes = StrictPropTypes({
});

module.exports = BasicSiteHeader;



// WEBPACK FOOTER //
// ./modules/components/layout/BasicSiteHeader.js